import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import PasswordFieldEdit from "./edit";
/** <b>Composant qui contient l'affichage d'un champ de type paswword en: </b>
 *  <li>Édition</li>
 */
export function Password() {
    return _jsx(_Fragment, { children: "Password" });
}
var field = fieldsType.password;
fieldsDictionary.registerField(FieldViewType.EDIT, field, PasswordFieldEdit);
